import React from "react";
import "./home.scss";
import Navbar from "../section/navbar/navbar";
import Header from "../section/header/header";
import About from "../section/about/about";
import Promo from "../section/promo/promo";
import Fasilitas from "../section/fasilitas/fasilitas.jsx";
import Rumah from "../section/rumah/rumah.jsx";
import Lokasi from "../section/lokasi/lokasi.jsx";
import Footer from "../section/footer/footer.jsx";
import tombol from "../media/tombol.webp";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ScrollToHashElement from "./ScrollToHashElement";
import Ruko from "../section/ruko/ruko.jsx";
import Video from "../section/video/video.jsx";
import Newlaunch from "../section/newlaunch/newlaunch.jsx";

const home = () => {
  return (
    <div className="home">
      <ScrollToHashElement />
      <Navbar />
      <Header />
      <About />
      <Newlaunch />
      <Video />
      <Promo />
      <Fasilitas />
      <Rumah />
      <Ruko />
      <Lokasi />
      <Footer />
    </div>
  );
};

export default home;
